import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TEMPLATE_ID } from "../../../../api/constants";
import celebrationImage from "../../../../assets/season-end.jpg";
import { getMyRankingRequest, getOverallRanking, getRankingRequest } from "../../../../redux/ranking";
import { getMyOverallRanking } from "../../../../redux/ranking/selectors";
import { getUser } from "../../../../redux/user";
import useFansUnitedSDK from "../.././../../hooks/useFansUnitedSDK";
import Countdown from "../Countdown/Countdown";
import styles from "./SeasonEnd.module.css";

const SeasonEnd = ({ nextSeasonDate = "19 April at 15:45", nextSeasonCountdown = { days: 84, hours: 16, minutes: 15, seconds: 37 } }) => {
	const { t } = useTranslation();
	const [_isLoading, setIsLoading] = useState(false);

	const overallRankingList = useSelector(getOverallRanking).slice(0, 10);
	const myRankingList = useSelector(getMyOverallRanking);
	const user = useSelector(getUser);

	const userRanking = myRankingList.filter((template) => template.id === TEMPLATE_ID)[0]?.position || "-";
	const userPoints = myRankingList.filter((template) => template.id === TEMPLATE_ID)[0]?.points || "-";

	const fansUnitedSDK = useFansUnitedSDK();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!fansUnitedSDK) return;

		const getData = () => {
			setIsLoading(true);
			dispatch(getRankingRequest(fansUnitedSDK)).then(() => {
				setIsLoading(false);
			});
		};

		const getPersonalRankingData = () => {
			setIsLoading(true);
			dispatch(getMyRankingRequest(fansUnitedSDK)).then(() => {
				setIsLoading(false);
			});
		};

		getData();
		getPersonalRankingData();
	}, [fansUnitedSDK, dispatch, setIsLoading]);

	return (
		<div className={styles.container}>
			{/* Next Season Countdown */}
			<Countdown initialTimeLeft={nextSeasonCountdown} deadline={nextSeasonDate} deadlineColor="#008500" />

			{/* Season Complete Message */}
			<div className={styles.messageCard}>
				<div className={styles.messageHeader}>
					<h2 className={styles.messageTitle}>{t("predictions.seasonEnd.title")}</h2>
				</div>
				<div className={styles.messageContent}>
					<p className={styles.messageText}>{t("predictions.seasonEnd.message")}</p>
					<p className={styles.messageSubtext}>{t("predictions.seasonEnd.subtitle")}</p>
				</div>
				<div className={styles.imageContainer}>
					<img src={celebrationImage} alt="Season celebration" className={styles.celebrationImage} />
				</div>
			</div>

			{/* User Position */}
			<div className={styles.leaderboardCard}>
				<div className={styles.leaderboardHeader}>
					<h3 className={styles.leaderboardTitle}>{t("predictions.seasonEnd.myPosition")}</h3>
					<div className={styles.leaderboardLabels}>
						<span className={styles.pointsLabel}>{t("predictions.seasonEnd.points")}</span>
						<span className={styles.rankLabel}>{t("predictions.seasonEnd.rank")}</span>
					</div>
				</div>
				<div className={styles.leaderboardList}>
					<div className={styles.leaderboardItem}>
						<div className={styles.playerInfo}>
							<span className={styles.playerName}>{user.name}</span>
						</div>
						<div className={styles.playerStats}>
							<span className={styles.playerPoints}>{userPoints}</span>
							<span className={styles.playerRank}>{userRanking}</span>
						</div>
					</div>
				</div>
			</div>

			{/* Top 10 Leaderboard */}
			<div className={styles.leaderboardCard}>
				<div className={styles.leaderboardHeader}>
					<h3 className={styles.leaderboardTitle}>{t("predictions.seasonEnd.topMembers")}</h3>
					<div className={styles.leaderboardLabels}>
						<span className={styles.pointsLabel}>{t("predictions.seasonEnd.points")}</span>
						<span className={styles.rankLabel}>{t("predictions.seasonEnd.rank")}</span>
					</div>
				</div>
				<div className={styles.leaderboardList}>
					{overallRankingList.map((player, index) => (
						<div key={index} className={styles.leaderboardItem}>
							<div className={styles.playerInfo}>
								<span className={styles.playerName}>{player.profileModel.name}</span>
							</div>
							<div className={styles.playerStats}>
								<span className={styles.playerPoints}>{player.points}</span>
								<span className={styles.playerRank}>{player.position}</span>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default SeasonEnd;
